import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface TransactionsState {
  transactions: any
  transactions_error: any
  retryTransactionSuccess: any
  retryTransactionError: any
  prnReleaseSuccess: any
  prnReleaseError: any
}

export interface TransactionFilters {
  page: number
  pageSize: number
  trackingNumber?: string
  prn?: string
  status?: string
  prnStatus?: string
  paymentMethod?: string
}

export const useTransactionsStore = defineStore('transactions', {
  state: (): TransactionsState => ({
    transactions: null,
    transactions_error: null,
    retryTransactionSuccess: null,
    retryTransactionError: null,
    prnReleaseSuccess: null,
    prnReleaseError: null,
  }),

  getters: {
    getTransactions: (state) => state.transactions,
    getTransactionsListError: (state) => state.transactions_error,
    getTransactionSuccess: (state) => state.retryTransactionSuccess,
    getTransactionError: (state) => state.retryTransactionError,
    getPRNReleaseSuccess: (state) => state.prnReleaseSuccess,
    getPRNReleaseError: (state) => state.prnReleaseError,
  },

  actions: {
    async fetchTransactions(data: TransactionFilters) {
      try {
        let path = `/billing/transaction/list?page=${data.page}&perPage=${data.pageSize}&dir=desc`
        if (data.trackingNumber) path += `&trackingNumber=${data.trackingNumber}`
        if (data.prn) path += `&prn=${data.prn}`
        if (data.status) path += `&status=${data.status}`
        if (data.prnStatus) path += `&prnStatus=${data.prnStatus}`
        if (data.paymentMethod) path += `&paymentMethod=${data.paymentMethod}`

        const response = await api().get(path)
        this.transactions = response.data.data
      } catch (error: any) {
        this.transactions_error = error
      }
    },

    async retryTransactionVerification(data: any) {
      try {
        const response = await api().post('/billing/transaction/query', data)
        this.retryTransactionSuccess = response.data
      } catch (error: any) {
        this.retryTransactionError = error
      }
    },

    async releasePRNTransaction(data: any) {
      try {
        const response = await api().post('/billing/transaction/prn-release', data)
        this.prnReleaseSuccess = response.data
      } catch (error: any) {
        this.prnReleaseError = error
      }
    },
  },
})
